module.exports = __webpack_public_path__ + "img/red-border-check.17f1263c.svg";